import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { getDDLValueByLabel } from "../../../common/Common";

interface IROEReportHeader {
	roeEmployeeDDLWithDateItems: any;
	setStateRunGetListAPICall: (value: boolean) => void
}

export const ROEReportHeader: React.FC<
	IROEReportHeader
> = ({ roeEmployeeDDLWithDateItems, setStateRunGetListAPICall }) => {
	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"employee"}
						items={roeEmployeeDDLWithDateItems ?? []}
						// selectedItem={"all"}
						label={"Employee"}
						testId={"roe-employee-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						showEmpty
					/>

					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						onClickHandler={() => setStateRunGetListAPICall(false)}
					/>

				</Grid>
			</Grid>
		</>
	);
};
